<div class="baselayer-selector-button-container" #baselayerSelectorButtonContainer
  id="baselayerSelectorButtonContainer">
  @if (showAsIcon) {
    <button mat-mini-fab aria-label="Layers" class="map-control-button" [ngClass]="{'active': isOpen()}" (click)="toggle()"
      id="baselayerSelectorButton" [matTooltip]="'base-layer-selector.choose-baselayer' | translate"
      matTooltipPosition="left">
      <mat-icon>layers</mat-icon>
    </button>
  }
</div>


<ng-template #baselayerPanel>
  @if (isOpen()|| isAnimating) {
    <div class="tmv-panel theme-baselayer-panel"
[class.open-animation]="isOpen()" 
    [class.close-animation]="!isOpen()"
    (transitionend)="handleAnimationDone($event)">

 
      <button matIconButton type="button" class="close" (click)="close()"
        matTooltipPosition="above"><mat-icon>close</mat-icon></button>
        <div>
          <h4>{{'base-layer-theme-selector.layers'|translate}}</h4>
          <mat-tab-group dynamicHeight [(selectedIndex)]="tabindex" [disableRipple]="true"
            (selectedTabChange)="switchTheme($event)" [disablePagination]="true">
            <!-- CW -->
            <mat-tab>
              <ng-template mat-tab-label>
                <div class="baselayer-widget-item">
                  <button class="baselayer-thumb theme" [ngClass]="getThemeClass(themekeys[0])"
                  matTooltipPosition="after"></button>
                  <div class="theme-label" [ngClass]="{'active': themes[themekeys[0]].active }">
                    {{"base-layer-theme-selector.theme-cartoweb"| translate}}
                  </div>
                </div>
              </ng-template>
              <!-- layers 1 -->
              <div class="layer-space">
                @for (layer of themes[themekeys[0]]; track layer) {
                  <div class="baselayer-widget-item">
                    <div class="layer-container flex-container row ">
                      <div class="icon-container" (click)="showPopover($event.target, layer.id)">
                        <mat-icon aria-label="">info</mat-icon>
                      </div>
                      <div (click)="switchBaseLayer(layer.id)" class="flex-container row align-center spacer layer-wrapper">
                        <button class="baselayer-thumb " [class.active]="layer.active" [ngClass]="this.getClassName(layer.id)">
                        </button>
                        <div class="layer-label " [ngClass]="{'active':layer.active}" [innerHTML]="layer.label">
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </mat-tab>
            <!-- CLASSIC MAPS -->
            <mat-tab>
              <ng-template mat-tab-label>
                <div class="baselayer-widget-item">
                  <button class="baselayer-thumb theme" [ngClass]="getThemeClass(themekeys[1])"
                  matTooltipPosition="after"></button>
                  <div class="theme-label" [ngClass]="{'active': themes[themekeys[1]].active }">
                    {{"base-layer-theme-selector.theme-classic"| translate}}
                  </div>
                </div>
              </ng-template>
              <!-- layers 2 -->
              <div class="layer-space">
                <mat-checkbox class="automatic-levels" [color]="primary" (change)="setAutomaticLevels($event.checked)"
                  [checked]="automaticLevels">
                  {{'base-layer-theme-selector.map-by-zoomlevel'| translate}}
                </mat-checkbox>
                @for (layer of themes[themekeys[1]]; track layer) {
                  <div class="baselayer-widget-item">
                    @if (layer.id != 'classic.maps') {
                      <span>
                        <div class="layer-container flex-container row ">
                          <div class="icon-container" (click)="showPopover($event.target, layer.id)">
                            <mat-icon aria-label="">info</mat-icon>
                          </div>
                          <div (click)="switchBaseLayer(layer.id)" class="flex-container row align-center spacer layer-wrapper">
                            <button class="baselayer-thumb " [class.active]="layer.id === autoActivatedLayerid()" [ngClass]="this.getClassName(layer.id)">
                            </button>
                            <div class="layer-label spacer" [ngClass]="{'active': layer.active}">
                              {{layer.label}}
                            </div>
                          </div>
                        </div>
                      </span>
                    }
                  </div>
                }
              </div>
            </mat-tab>
            <!-- ORTHOS -->
            <mat-tab>
              <ng-template mat-tab-label>
                <div class="baselayer-widget-item">
                  <button class="baselayer-thumb theme" [ngClass]="getThemeClass(themekeys[2])"></button>
                  <div class="theme-label" [ngClass]="{'active': themes[themekeys[2]].active }">
                    {{"base-layer-theme-selector.theme-ortho"| translate}}
                  </div>
                </div>
              </ng-template>
              <!-- layers 3 -->
              <div class="layer-space">
                @for (layer of themes[themekeys[2]]; track layer) {
                  <div class="baselayer-widget-item ">
                    <div class="layer-container flex-container row ">
                      <div class="icon-container" (click)="showPopover($event.target, layer.id)">
                        <mat-icon aria-label="">info</mat-icon>
                      </div>
                      <div (click)="switchBaseLayer(layer.id)" class="flex-container row align-center spacer layer-wrapper">
                        <button class="baselayer-thumb " [class.active]="layer.active" [ngClass]="this.getClassName(layer.id)">
                        </button>
                        <div class="layer-label spacer" [ngClass]="{'active':layer.active}">{{layer.label}}
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    }
  </ng-template>